export var AGB = "agb";
export var PRIVACY = "privacy";
